const timeLeft = (startedAt: Date, duration: number) => {
  const now = Date.now();
  return Math.min(
    duration,
    Math.max(0, (startedAt.getTime() - now) / 1000 + duration),
  );
};

export default timeLeft;
